/** @format */

import angular from 'angular';
import angularAnimate from 'angular-animate';

import { ImageLoaderModule } from 'crowdcomms-js/lib/ui/image-loader';
import { UiModule as gbUiModule } from 'crowdcomms-js/lib/galabid/ui';

import { UiConfig } from './ui.config.js';

export const UiModule = angular
    .module('galabid-presenter.shared.ui', [angularAnimate, ImageLoaderModule, gbUiModule])
    .config(UiConfig).name;
